import {ColumnsType} from "antd/lib/table/interface";
import React from "react";
import {SystemUser} from "../../../../models/users/user/system.user";
import { Link } from "react-router-dom";
import {Translate} from "../../../../hooks/translate.hook";
import {DailyStatement} from "../../../../models/accounting/daily-statements";
import Date from "../../../date/date";

export const columnsFactory = (t: Translate): ColumnsType<DailyStatement> => {
    return [
        {
            title: "ID",
            dataIndex: "id",
            key: "id"
        },
        {
            title: t("DATE"),
            dataIndex: "onDate",
            key: "onDate",
            render: v => <Date dateString={v} />
        },
        {
            title: t("USER.TITLE"),
            dataIndex: "accountant",
            key: "accountant",
            width: "255px",
            render: (accountant: SystemUser) => accountant.lastName + ' ' + accountant.firstName,
        },
        {
            title: t("MISSMATCHES"),
            dataIndex: "mismatches",
            key: "mismatches",
            width: "125px"
        },
        {
            title: t("ACTIONS.TITLE"),
            key: "actions",
            dataIndex: "id",
            render: (id: number) => <Link to={"/accounting/daily-statements/" + id} className="ant-btn ant-btn-primary">
                {t("VIEW")}
            </Link>
        }
    ];
}